var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as PaymentMethodFactory from "../../classes/definitions/paymentMethod/paymentMethod";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import PaymentMethodsList from '../../components/PaymentMethods/PaymentMethodsList/PaymentMethodsList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./PaymentMethodsReduxProps";
var PaymentMethods = /** @class */ (function (_super) {
    __extends(PaymentMethods, _super);
    function PaymentMethods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: []
        };
        _this.getAllPaymentMethods = function () {
            _this.api.getPaymentMethods()
                .then(function (response) {
                var methods = PaymentMethodFactory.createPaymentMethods(response.data);
                _this.setState({ data: methods });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим методите за плащане.', _this.props.history);
            });
        };
        _this.toNewPaymentMethod = function () {
            _this.props.history.push(AppRoutes.paymentMethod.path);
        };
        return _this;
    }
    PaymentMethods.prototype.componentDidMount = function () {
        this.getAllPaymentMethods();
    };
    PaymentMethods.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041C\u0435\u0442\u043E\u0434\u0438 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewPaymentMethod, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u043C\u0435\u0442\u043E\u0434 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(PaymentMethodsList, { gridData: data }))))));
    };
    return PaymentMethods;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(PaymentMethods);



//////////////////
// WEBPACK FOOTER
// ./src/views/PaymentMethods/PaymentMethods.tsx
// module id = 399
// module chunks = 0